import React from 'react';
import Landing from './components/Landing';
// import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Landing />
      {/* <Footer /> */}
    </div>
  );
}

export default App;